import {inject, InjectionKey} from 'vue'
import axios, {AxiosInstance} from 'axios'
import {UserSessionData} from './useUserSession'
import useNotyf from '/@src/composable/useNotyf'
import {ApolloClient, ApolloLink, createHttpLink, InMemoryCache, from} from '@apollo/client/core'
import {DefaultApolloClient} from '@vue/apollo-composable'
import {setContext} from "@apollo/client/link/context";
import {CommonResponse} from "/@src/models/api";
import {onError}  from "@apollo/client/link/error";

const notif = useNotyf()

export const apiSymbol: InjectionKey<Record<string, AxiosInstance>> = Symbol()

export function initApi(session: UserSessionData) {

  // Here we set the base URL for all requests made to the api
  const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL as string,
  })

  // We set an interceptor for each request to
  // include Bearer token to the request if user is logged in
  api.interceptors.request.use((config) => {
    // if (session.token) {
    //   config.headers.Authorization = `Bearer ${session.token}`
    // }
    if(config.headers){
      if (session.token) {
        config.headers['X-Hufu-Token'] = session.token
        // 去除缓存
        config.headers['cache-control'] = 'no-store'
      }
      // 新接口没有v1标识
      if(config.url&&config.url.indexOf('/v1')<0){
        config.baseURL = import.meta.env.VITE_API2_BASE_URL as string
      }
    }

    return config
  })
  api.interceptors.response.use((response) => {
    // 判断是否完整路径请求外部数据
    if(!response.config.url!!.startsWith('http')){
      const res = response.data as CommonResponse
      if (res.status === 1) {
        // 业务错误
        notif.error(res.message!!)
        if(res.code === 50008||res.code === 50014){
          session.token = ''
        }else {
          throw new Error(res.message)
        }
      }
      const data = res.data
      return data
    }else {
      return response.data
    }

  },error => {
    if(error.message){
      notif.error(error.message)
    }
  })
  // provide(apiSymbol, api)

  return api
}

export type ApiId = 'default' | 'sourceApi'|'dataApi'

export default function useApi(clientId?:ApiId): AxiosInstance {
  const clients = inject(apiSymbol)
  if (!clients) {
    throw new Error('Api not properly injected in app')
  }
  const api = clients[clientId || 'default']
  if (!api) {
    throw new Error('Api client not found')
  }
  return api
}

const responseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    // 服务器返回数据
    return response.data
  })
})
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
    if(networkError.message){
      notif.error(networkError.message)
    }else {
      notif.error('Unknown server error')
    }
  }
});
// Cache implementation
const cache = new InMemoryCache()
export function initGraphql(session: UserSessionData) {
  // HTTP connection to the API
  const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: import.meta.env.VITE_GRAPHQL_BASE_URL as string,
    // headers:{
    //   "x-token":session.token
    // }
  })
  const authLink = setContext( (req, params ) => {
    return {
      headers: {
        'x-token': session.token
      }
    }
  });
  const link = ApolloLink.from([
    authLink,
    responseLink,
    errorLink,
    httpLink
  ])
// Create the apollo client
  return new ApolloClient({
    link: link,
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        // all为即使有error也正常获取
        errorPolicy: 'all'
      }
    }
  })
}

export function useApollo():ApolloClient<any>{
  const gql = inject(DefaultApolloClient) as ApolloClient
  if (!gql) {
    throw new Error('GraphQl not properly injected in app')
  }
  return gql
}

export function otherClient() {
  const httpLink = createHttpLink({
    uri: import.meta.env.VITE_API_BASE_URL as string + '/graphql/',
  })
  const authLink = setContext( () => {
    return {
      headers: {
        'X-Hufu-Token': localStorage.getItem('token'),
      }
    }
  });
  const link = ApolloLink.from([
    authLink,
    responseLink,
    errorLink,
    httpLink
  ])

  return new ApolloClient({
    link: link,
    cache,
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        // all为即使有error也正常获取
        errorPolicy: 'all'
      },
      mutate:{
        errorPolicy: 'all'
      }
    }
  })

}
